import React from "react";
import { Grid, Segment, Header } from "semantic-ui-react";

const PreReqCheckbox = () => (
  <Grid>
    <Grid.Row>
      <Grid.Column>
        <Header size="large" content="Welcome to the Checkbox, all requirements below must be met before proceeding to step 1!" />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column>
        <Segment secondary raised>
          I have read, watched, listed to the Tafsir and wrote some brief notes on each ayah to think about while reciting.
        </Segment>
      
        <Segment secondary raised>
          I know a word by word translation of each ayah and I have written the words that I don’t know over the words in my Quran with a pencil. (If you don’t know more than 30% of the words in the ayah then do this in your notes, not the Quran)
        </Segment>
      
        <Segment secondary raised>
        I have my Quran open and I am using a Quran app that repeats verses and I am listening to an approved Shiek (Mishary Rashid Al Afasy, Abdul-Basit, Mohammad Al-Minshawi, Khalil Al Husari, Ali Abdurrahman Al-Huthaifi, Mohammad Ayub, Mahmoud AlBana, Ahmad Talib Hameed)! 
        </Segment>
      
        <Segment secondary raised>
          I know I am reciting correctly. (If I need help I will send my teacher a recording and ask questions and I will circle my mistakes) 
        </Segment>
        
        <Segment secondary raised>
          I LISTENED TO AYMEN RUSHDI SUAYD AT LEAST ONCE FOR MY VERSES
        </Segment>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
export default PreReqCheckbox;